// Remix Screen: Video Bucket List
// author rodolfo lopez pintor <rlp@nebular.tv>
//////////////////////////////////////////////////////////////
//noinspection DuplicatedCode

import m from "mithril";
import dayjs from 'dayjs'
import {filesize} from 'filesize'

import {
	defineWidget, Icon, ButtonNew, Notification
} from "@nebularstreams/libmui"

import {insertVideo, contains} from "../../Api";
import {ContentBrowser} from "../misc/ContentBrowser";

//////////////////////////////////////////////////////////////
// VIDEO BUCKET LIST: STRINGS

const STR = {
	PREVIEW: "click to preview this video, or click icons to the right to add the video to the reMix",
	CLIP_ADDED: "Clip Added to Playlist",
	YOUR_VIDEOS: "Your Videos in nanoStream Storage",
	YOUR_VIDEOS_EMPTY: "No videos in your nanoStream Storage\nTo create a reMix you first need to upload some videos.\nTry drag-and-drop from your File explorer, or press the button below.",
	YOUR_VIDEOS_EMPTY_FILTER: "No videos matching your search\nPlease refine the search term",
	UPLOAD_VIDEO: "Upload a video from your computer",
};

//////////////////////////////////////////////////////////////


//////////////////////////////////////////////////////////////
// UI WIDGETS

let
	statePreview = null;        // current item preview (replayer)

const

	///////////////////////////////////////////////////////////
	// BUCKET CONTENTS

	// widget: The Bucket Item
	ContentItem = defineWidget(
		({attrs, state}) => {

			const
				STATE = attrs.state,
				usePlaylist = STATE.service === "remix"
					? STATE.livePlaylistStatus?.playing
						? STATE.livePlaylist
						: STATE.currentSetlist
					: false;

			return [

				// actual item
				m("li.flexrow.fadein",
					{
						title: STR.PREVIEW,
						class: statePreview === attrs.item.key ? "preview" : "",
						draggable: true,
						ondragstart: (e) => {
							e.dataTransfer.effectAllowed = "copy";
							const payload = JSON.stringify({
								type: "videoItem",
								key: attrs.item.key,
								url: attrs.item.url || `${attrs.webroot}/${attrs.item.key}`
							});
							e.dataTransfer.setData("text/plain", payload);
							state.dragging = true;
							m.redraw();
						},
						ondragend: () => {
							state.dragging = false;
							m.redraw();
						},
					},
					[
						m(Icon, {
							iconClass: "pad-1 pad-h", icon: attrs.item.url ? "broadcast-tower" : "film",
						}),
						m("span.name.grows.ellipsis.ohidden",
							{
								onclick: () => {

									STATE.focusedItem = attrs.item;
									if (!attrs.nopreview) {
										if (statePreview !== attrs.item.key) {
											statePreview = attrs.item.key;
										} else statePreview = null;
										if (attrs.onClick) attrs.onClick(statePreview);
									}
									m.redraw();
								}
							},
							attrs.prefix ? attrs.item.key.split(attrs.prefix)[1] : attrs.item.key
						),
						...attrs.item.size ? [
							m("span.size.col-2", filesize(attrs.item.size)),
							m("span.date.col-2", dayjs(attrs.item.date).fromNow()),
						] : [],

						...usePlaylist
							? [
								m(ButtonNew, {
									icon: contains(attrs.item.key, usePlaylist) ? "check" : "plus",
									class: "unitwidth",
									onClick: () => insertVideo(
										usePlaylist,
										attrs.item.url || `${attrs.webroot}/${attrs.item.key}`,
										undefined,
										undefined
									)
										.then(() => {
											Notification.add(STR.CLIP_ADDED);
											statePreview = null;
											m.redraw()
										})
										.catch((e) => Notification.add(e.message))
								})
							] : []
					]),

				// video preview
				...statePreview === attrs.item.key && !attrs.item?.url
					? [
						m(
							"li.embedimage.grows.fadein",
							{
								draggable: true,
								ondragstart: (e) => {
									e.dataTransfer.effectAllowed = "copy";
									const payload = JSON.stringify({
										type: "videoItem",
										key: attrs.item.key,
										url: attrs.item.url || `${attrs.webroot}/${attrs.item.key}`
									});
									e.dataTransfer.setData("text/plain", payload);
									state.dragging = true;
									m.redraw();
								},
								ondragend: () => {
									state.dragging = false;
									m.redraw();
								},
							},
							m("video", {
								alt: "video " + attrs.item.key.split("/").pop(),
								src: ([attrs.webroot, attrs.item.key].join("/")),
								preload: "auto",
								muted: true,
								autoplay: "false",
								oncreate: ({dom}) => dom.scrollIntoView({behavior: "smooth", block: "center"}),
								onclick: () => {
									statePreview = null;
									m.redraw();
								}
							})
						),
					]
					: []
			]
		}
	),

	// widget: the list of videos in the bucket
	VideoContent = defineWidget(
		({attrs}) => m(ContentBrowser, {
			state: attrs.state,
			noUpload: false,
			filter: true,
			collapsed: true,
			accept: "video/mp4",
			service: attrs.state.service,
			orga: attrs.orga,
			prefix: `${attrs.state.service}/${attrs.orga}/`,
			title: STR.YOUR_VIDEOS,
			emptyMessage: STR.YOUR_VIDEOS_EMPTY,
			emptyFilter: STR.YOUR_VIDEOS_EMPTY_FILTER,
			uploadMessage: STR.UPLOAD_VIDEO,
			itemWidget: ContentItem
		})
	);

export default VideoContent;
export {ContentItem};
